import { render, staticRenderFns } from "./import-wizard.vue?vue&type=template&id=12b12671&scoped=true"
import script from "./import-wizard.vue?vue&type=script&lang=js"
export * from "./import-wizard.vue?vue&type=script&lang=js"
import style0 from "./import-wizard.vue?vue&type=style&index=0&id=12b12671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b12671",
  null
  
)

export default component.exports